import enAntd from 'antd/es/locale/en_US';

const EnLang = {
  locale: 'en',
  antd: enAntd,
  messages: {
    "topbar.notification": "Notifications",
    "topbar.notification.emptyMessage": "You Have No Pending Notifications",
    "topbar.viewAll": "View All",
    "topbar.changePassword": "Change Password",
    "topbar.logout": "Logout",

    "app.auditors": "Auditors",
    "app.auditor": "Auditor",
    "app.here": "Here",
    "app.yes": "Yes",
    "app.no": "No",
    "app.plant": "Facility",
    "app.customer": "Customer",
    "app.supplier": "Supplier",
    "app.project": "Project",
    "app.pinned": "Pinned",
    "app.record": "Records",
    "app.allRecords": "All Records",
    "app.filterApplied": "Filter Applied",
    "app.currentVersion": "Current Version",
    "app.oldVersion": "Old Version",
    "app.open": "Open",
    "app.closed": "Closed",
    "app.read": "Read",
    "app.unread": "Unread",
    "app.customerCount": "Customer Count",
    "app.itemSelected": "Item Selected",
    "app.all": "All",
    "app.file": "File",
    "app.processing": "Your request is being processed...",
    "app.update.success": "Successfully updated.",
    "app.update.error": "An error occurred while updating. Please try again.",
    "app.save.success": "Successfully saved",
    "app.save.error": "An error occurred while saving. Please try again.",
    "app.delete.success": "Successfully deleted.",
    "app.delete.error": "An error occurred while deleting. Please try again.",
    "app.scope": "Scope",
    "app.breakdown": "Breakdown",
    "app.source": "Source",
    "app.request.success": "Your request has been successfully submitted.",
    "app.request.success.redirectProjectEdit": "Your request has been successfully submitted. Redirecting to the project edit screen...",
    "app.active": "Active",
    "app.inactive": "Inactive",
    "app.onlyEditableInFirstStage": "Can only be changed in the first stage!",
    "app.plantSupplier": "Facility / Supplier",
    "app.summary": "Summary",
    "app.integration": "Integration",
    "app.registration.success": "Your registration has been successfully completed. Redirecting to the login page.",
    "app.retry": "Retry",
    "app.pleaseWait": "Please wait until your process is completed.",
    "app.categories": "Categories",
    "app.categories.placeholder": "Select Category",
    "app.formula": "Formula",
    "app.reference": "Reference",
    "app.createdBy": "Created By",
    "app.updatedBy": "Updated By",
    "app.recordApproved": "Your record has been approved.",
    "app.recordNotApproved": "The record has not been approved yet.",
    "app.filesSaved": "Saved Files",
    "app.overallTotal": "Overall Total",
    "app.upstream": "Upstream",
    "app.downstream": "Downstream",
    "app.numeric.placeholder": "e.g. 100",
    "app.show.more": "Show More (+{n})",
    "app.show.less": "Show Less",
    "eos.tooltip": "Would you like to offset your carbon footprint?",

    "invitation.link.invalid.title": "Invalid Link",
    "invitation.link.invalid.subTitle": "The invitation link may be invalid or expired. Please contact the customer to request a new invitation.",
    "invite.accepted": "Invitation Accepted",
    "invite.accepted.success": "You have been successfully linked. You can now start working with this customer as a supplier.",

    "relation.customerSupplier.title": "Customer–Supplier Relationship",
    "relation.supplierInvitation.title": "Supplier Invitation",
    "relation.customerSupplier.remove.confirm": "Are you sure you want to remove the customer–supplier relationship?",
    "relation.customerSupplier.add.confirm": "Are you sure you want to link the customer and supplier?",
    "relation.supplierInvitation.send.confirm": "Are you sure you want to send an invitation to the supplier?",

    "chart.trendline": "Trend Line",
    "chart.zoom": "Zoom chart",
    "chart.defaultTitle": "Chart",
    "chart.closeHint": "Click the top-right close to exit.",

    "login.signIn": "Sign In",
    "login.username.placeholder": "Username",
    "login.password.placeholder": "Password",
    "login.forgotPassword": "Forgot Your Password?",
    "login.forgotPasswordQuestion": "Forgot your password?",
    "login.resetPasswordInstruction": "Enter your email address and we'll send you a reset link.",
    "login.usernameOrEmail": "Username or Email",
    "login.bookDemo": "Book a Demo",
    "login.bookDemo.subtitle": "To quickly schedule with our sustainability consultants, <click>click here</click>",

    "passwordChange.success": "Password has been successfully changed.",
    "passwordChange.error": "Password change failed. Please try again.",
    "passwordChange.expiredMessage": "Your last password change was 90 days ago. Please update your password.",
    "passwordChange.oldPassword": "Old Password",
    "passwordChange.newPassword": "New Password",
    "passwordChange.confirmPassword": "Confirm Password",
    "passwordChange.oldPasswordRequired": "Old Password is required!",
    "passwordChange.newPasswordRequired": "New Password is required!",
    "passwordChange.confirmPasswordRequired": "Confirm Password is required!",
    "passwordChange.passwordsMustBeDifferent": "Old password and new password must be different!",
    "passwordChange.passwordsMustMatch": "New password and confirm password must match!",
    "passwordChange.passwordsMustBeAtLeast6Characters": "Password must be at least 6 characters long.",
    "paswordChange.passwordUpdate": "Password Update",

    "sidebar.mainForm": "Dashboard",
    "sidebar.customer": "Customers",
    "sidebar.supplier": "Suppliers",
    "sidebar.plants": "Facilities",
    "sidebar.projects": "Projects",
    "sidebar.userList": "Users",
    "sidebar.emissionStatements": "Emission Factors",
    "sidebar.notifications": "Notifications",
    "sidebar.fileHandler": "File Manager",
    "sidebar.logs": "Logs",
    "sidebar.administrator": "System",

    "notification.title": "Notifications",
    "notification.markAsRead": "Mark as Read",
    "notification.column.type": "Notification Type",
    "notification.column.description": "Description",
    "notification.column.readStatus": "Read Status",
    "notification.column.createdBy": "Created By",
    "notification.column.createdAt": "Created At",
    "notification.column.readAt": "Read At",
    "notification.filter.type.placeholder": "Select Notification Type",
    "notification.filter.keyword.placeholder": "Enter User, First Name, Last Name, Description",

    "projectWizard.title": "Project Definition",
    "projectWizard.validation.client.required": "Customer selection is required.",
    "projectWizard.validation.protocolType.required": "Protocol type selection is required.",
    "projectWizard.validation.name.required": "Project name is required.",
    "projectWizard.validation.start.required": "Start date is required.",
    "projectWizard.validation.end.required": "End date is required.",

    "project.compare": "Project Comparison",
    "project.type": "Project Type",
    "projects.title": "Projects",
    "projects.emptyMessage": "You Have No Pinned Projects.",
    "projects.newProject": "New Project",
    "projects.createNewProject": "Create New Project",
    "project.filter.events.title": "Event",
    "project.filter.events.placeholder": "Include event projects",
    "project.filter.status.title": "Status",
    "project.filter.status.placeholder": "Select status",
    "project.filter.emissionStatus.title": "Emission Status",
    "project.filter.emissionStatus.placeholder": "Select emission status",
    "project.filter.protocolType.title": "Protocol Type",
    "project.filter.protocolType.placeholder": "Select protocol type",
    "project.filter.client.title": "Client",
    "project.filter.client.placeholder": "Select client",
    "project.filter.keyword.placeholder": "Enter Project Name, Version, Client Name",
    "project.options.all": "All",
    "project.options.approvedOnly": "Only Approved Projects",
    "project.options.unapprovedOnly": "Only Unapproved Projects",
    "project.options.active": "Active",
    "project.options.inactive": "Inactive",
    "project.delete.title": "Delete Project",
    "project.delete.message": "Are you sure you want to delete this project?",
    "project.compare.selectedProjects": "Compare Selected Projects",
    "project.compare.maxTwoProjectsAllowed": "You can select up to two projects for comparison.",
    "project.compare.sameProtocolRequired": "Projects must have the same protocol type to be compared.",
    "project.card.emissionVersion": "Emission Version Used in Project",
    "project.card.auditor.notFound": "Assigned auditor not found",
    "project.card.totalCO2e": "Total CO2e",
    "project.card.button.pin": "Pin",
    "project.card.button.unpin": "Unpin",
    "project.column.name": "Name",
    "project.column.client": "Client",
    "project.column.status": "Status",
    "project.column.version": "EF Version",
    "project.column.version.tooltip": "Indicates the version of Emission Factors used in the project",
    "project.column.protocolType": "Protocol Type",
    "project.column.isEvent": "Event?",
    "project.type.event": "This is an event project.",
    "project.pastDateWarning": "This project is from a past date and cannot be used actively. Please update the project status to 'Inactive'.",
    "project.headquartersRelationRemoveError": "The relationship with the headquarters facility cannot be removed.",
    "project.calculateAndAllocateSupplierEmissions.success": "Supplier emissions have been successfully calculated and allocated.",
    "project.calculateAndAllocateSupplierEmissions.error": "Supplier emissions could not be calculated and allocated. Please try again.",
    "project.calculateAndAllocateSupplierEmissions": "You have data that requires approved transfer allocation.",
    "project.calculateAndAllocateSupplierEmissions.description": "Start Transfer",
    "project.supplierPlantQuantity.saveError": "Production volume could not be saved. Please try again.",
    "project.supplierPlantQuantity.saveSuccess": "Production volume has been successfully saved.",

    "plant.title": "Facilities",
    "plant.newPlant": "New Facility",
    "plant.createNewPlant": "Create New Facility",
    "plant.save.success": "Facility has been successfully registered.",
    "plant.save.error": "Facility registration failed. Please try again.",
    "plant.delete.title": "Delete Facility",
    "plant.delete.message": "Are you sure you want to delete this plant?",
    "plant.delete.success": "Facility has been successfully deleted.",
    "plant.delete.error": "Facility deletion failed. Please try again.",
    "plant.filter.customer.title": "Customer",
    "plant.filter.customer.placeholder": "Select Customer",
    "plant.filter.keyword.placeholder": "Enter Facility Name, Tax Office",
    "plant.column.customer": "Client",
    "plant.relation.notFound": "No linked plant was found",

    "versioningEmission.info": "Please remember to save after completing the required review!",
    "versioningEmission.title": "Emission Factor Versioning & Preview",
    "versioningEmission.save.success": "New emission version created successfully",
    "versioningEmission.save.error": "Failed to create the emission version. Please try again",

    "log.title": "Event Logs",
    "log.filter.user.title": "Users",
    "log.filter.user.placeholder": "Select User",
    "log.filter.logSource.title": "Event Source",
    "log.filter.logSource.placeholder": "Select Event Source",
    "log.filter.logType.title": "Event Type",
    "log.filter.logType.placeholder": "Select Event Type",
    "log.filter.keyword.placeholder": "Enter User First Name, Last Name, Description...",
    "log.column.userName": "User Name",
    "log.column.date": "Date",
    "log.column.logSource": "Event Source",
    "log.column.logType": "Event Type",
    "log.column.description": "Description",
    "log.column.ipAddress": "IP Address",
    "log.column.roleName": "Role",

    "user.title": "Users",
    "user.newUser": "New User",
    "user.createNewUser": "Create New User",
    "user.notFound": "User not found.",
    "user.save.success": "User has been successfully saved.",
    "user.save.error": "User save failed. Please try again.",
    "user.delete.success": "User has been successfully deleted.",
    "user.delete.error": "User deletion failed. Please try again.",
    "user.changePassword.success": "Password has been successfully changed.",
    "user.changePassword.error": "Password change failed. Please try again.",
    "user.role.required": "User role cannot be empty",
    "user.update.title": "Update User",
    "user.update.description": "Updating the user may result in loss of some data. Do you want to continue?",
    "user.delete.title": "Delete User",
    "user.delete.description": "The user will be deleted. Do you want to continue?",
    "user.modal.tabs.general": "General",
    "user.modal.tabs.customerProject": "Customer / Project",
    "user.modal.tabs.customerProject.tooltip": "This tab is for users with Auditor permission",
    "user.filter.keyword.placeholder": "Enter First Name, Last Name, Title, Email...",
    "user.column.username": "Username",
    "user.column.firstName": "First Name",
    "user.column.lastName": "Last Name",
    "user.column.status": "Status",
    "user.cloumn.role": "Role",
    "user.column.title": "Title",
    "user.column.mail": "Email",
    "user.column.filePermissions": "F. Permissions",
    "user.column.client": "Client Name",
    "user.column.createDate": "Creation Date",
    "user.activeProjectCount": "Active Project Count",
    "user.validation.username.duplicate": "Username is already taken.",

    "dashboard.title": "Dashboard",
    "dashboard.compare.panel": "Project Comparison Panel",
    "dashboard.project.title": "Project Dashboard",

    "activityData.title": "Activity Data",
    "activityData.goToDashboard": "Go to project dashboard",
    "activityData.scope3.title": "Supplier Data Information",
    "activityData.scope3.description": "If you believe there are supplier data that have not been transferred, these data will be available in the relevant tab after auditor or system administrator approval. Please wait until the approval process is complete.",
    "activityData.carbonFootprint.alert.title": "Do you have calculated carbon footprint data?",
    "activityData.carbonFootprint.alert.description": "If you have previously calculated carbon footprint data, you can start the bulk data entry process from here. Click the 'Enter Emissions' button to quickly upload your existing data.",
    "activityData.carbonFootprint.alert.button": "Enter Emissions",

    "supplier.title": "Suppliers",
    "supplier.newSupplier": "New Supplier",
    "supplier.definition.title": "Supplier Definition",
    "supplier.createNewSupplier": "Create New Supplier",
    "supplier.save.success": "Supplier has been successfully registered.",
    "supplier.save.error": "Supplier registration failed. Please try again.",
    "supplier.delete.title": "Delete Supplier",
    "supplier.delete.message": "Are you sure you want to delete this supplier?",
    "supplier.delete.success": "Supplier has been successfully deleted.",
    "supplier.delete.error": "Supplier deletion failed. Please try again.",
    "supplier.filter.customer.title": "Customer",
    "supplier.filter.customer.placeholder": "Select Customer",
    "supplier.filter.keyword.placeholder": "Enter Supplier Name, Version, Customer Name",
    "supplier.relationships": "Supplier Relationships",
    "supplier.relationships.placeholder": "Select supplier relationship",
    "supplier.subRelationship": "Supplier Sub-Relationship",
    "supplier.subRelationship.placeholder": "Select supplier sub-relationship",
    "supplier.relation.save.success": "The relationship has been saved successfully.",
    "supplier.relation.save.error": "Failed to save the relationship. Please try again.",
    "supplier.relation.alert.unmapped": "Relationships have not been defined yet",
    "supplier.relation.alert.allMapped": "All relationships have been defined",
    "supplier.relation.button.define": "Define Relationship",
    "supplier.relation.button.view": "View Relationships",
    "supplier.relation.notFound": "No linked supplier was found",

    "customer.title": "Customers",
    "customer.newCustomer": "New Customer",
    "customer.createNewCustomer": "Create New Customer",
    "customer.save.success": "Customer has been successfully registered.",
    "customer.save.error": "Customer registration failed. Please try again.",
    "customer.delete.title": "Delete Customer",
    "customer.delete.message": "Are you sure you want to delete this customer?",
    "customer.delete.success": "Customer has been successfully deleted.",
    "customer.delete.error": "Customer deletion failed. Please try again.",
    "customer.filter.status.title": "Status",
    "customer.filter.status.placeholder": "Select status",
    "customer.filter.supplier.title": "Supplier",
    "customer.filter.supplier.placeholder": "Select supplier",
    "customer.filter.organizationBoundaryMethods.title": "Organization Boundary",
    "customer.filter.organizationBoundaryMethods.placeholder": "Select Organization Boundary Methods",
    "customer.filter.keyword.placeholder": "Enter Customer Name, Version, Supplier Name",
    "customer.options.active": "Active",
    "customer.options.inactive": "Inactive",

    "client.column.companyName": "Company Name",
    "client.column.name": "Name",
    "client.column.boundaryMethod": "Boundary Method",
    "client.column.status": "Status",
    "client.column.person": "Contact Person",
    "client.column.email": "Email",
    "client.column.phone": "Phone",
    "client.column.taxNumber": "Tax Number",
    "client.column.taxOffice": "Tax Office",
    "client.column.address": "Address",
    "client.column.city": "City",
    "client.column.region": "Region",
    "client.column.country": "Country",

    "emission.analysis": "Emission Analysis",
    "emission.totals": "Emission Totals",
    "emission.supplierEmissions": "Supplier Emissions",
    "emission.type.supplierAllocation": "Transferred Emission",
    "emission.type.providedEmission": "Calculated Emission",
    "emission.totalCards.noData": "No data has been entered yet for displaying emission total cards. To get started, click {link}.",
    "emission.graph.noData": "No data has been entered yet for the CO₂e emissions chart display.",
    "emission.map.noData": "To view the value chain map, the supplier data must be approved by an auditor or system administrator.",
    "emission.column.purch.lineItem": "Purchase Line Item",
    "emission.column.sold.quantity": "Sold Product Quantity",
    "emission.column.activity": "Usage Phase Activity",
    "emission.column.functionalUnit.activityData": "Lifecycle Activity Data",
    "emission.column.year": "Year",
    "emission.column.loan-useful": "Amount",
    "emission.column.dataset": "Dataset",
    "emission.column.emissionSource": "Emission Source",
    "emission.column.sectorInfo": "Detail Information",
    "emission.column.hotelName": "Hotel Name",
    "emission.column.employeeName": "Employee Name",
    "emission.column.arrivalDate": "Arrival Date",
    "emission.column.departureDate": "Departure Date",
    "emission.column.checkIn": "Check-in Date",
    "emission.column.checkOut": "Check-out Date",
    "emission.column.durationIndex": "Duration Index",
    "emission.column.peopleCount": "People Count",
    "emission.column.country": "Country",
    "emission.column.unit": "Unit",
    "emission.column.value": "Value",
    "emission.column.fuelType": "Fuel Type",
    "emission.column.airportDeparture": "Departure Airport",
    "emission.column.airportArrival": "Arrival Airport",
    "emission.column.distance": "Distance/User Data",
    "emission.column.flightClass": "Flight Class",
    "emission.column.gasType": "Gas Type",
    "emission.column.gasAmount": "Gas Amount",
    "emission.column.gasLeakageRate": "Gas Leakage Rate",
    "emission.column.emissionCO2": "Emission CO₂",
    "emission.column.emissionCH4": "Emission CH₄",
    "emission.column.emissionN2O": "Emission N₂O",
    "emission.column.emissionCO2e": "Emission CO₂e",
    "emission.column.description": "Description",
    "emission.column.transportType": "Transport Type",
    "emission.column.amount": "Amount",
    "emission.column.actionDate": "Action Date",
    "emission.column.documentName": "Document Name",
    "emission.column.documentDate": "Document Date",
    "emission.column.kyoto.onlyKyotoEmissions": "Only emissions containing Kyoto greenhouse gases",
    "emission.column.kyoto.totalEmissionsIncludingNonKyoto": "Total emissions including non-Kyoto greenhouse gases",
    "emission.column.kyoto.onlyNonKyotoEmissions": "Only emissions containing non-Kyoto greenhouse gases",
    "emissio.column.lowerHeatingValue": "Lower Heating Value",
    "emission.column.density": "Density",
    "emission.column.nace": "Relation",
    "emissions.totalCalculated": "Total Calculated Emissions",
    "emissions.valueChainMap": "Value Chain Map",
    "emission.column.percentWithinSuppliers": "Share Among Suppliers (%)",
    "emission.column.percentWithinAll": "Share of Total Emissions (%)",
    "emission.options.stationary.name": "Stationary product",
    "emission.options.mobile.name": "Mobile product",
    "emission.options.fertilizer.name": "Fertilizer",
    "emission.options.process.name": "Process product",
    "emission.options.refrigerant.name": "Refrigerant gas",
    "emission.options.fireExt.name": "Fire extinguisher",

    "emissionStatements.title": "Emission Factors",
    "emissionStatements.newEmissionStatement": "New Emission Statement",
    "emissionStatements.registeredEmissionFactors": "Registered Emission Factors",
    "emissionStatements.column.greenhouseGas": "Greenhouse Gas",
    "emissionStatements.column.unit": "Unit",
    "emissionStatements.column.value": "Value",
    "emissionStatements.column.total": "Total",
    "emissionStatements.column.fuelType": "Fuel Type",
    "emissionFactor.wizard.totalStatementValue": "Total Value",
    "emissionStatements.uploadFile.hint": "You can upload one file at a time. Only Excel files are allowed.",
    "emissionStatements.uploadFile.error": "File upload failed. Please try again.",

    "emissionFactor.wizard.title": "New Emission Factor",
    "emissionFactor.wizard.subtitle": "Emission Factor Definition",
    "emissionFactor.wizard.level1": "Level 1",
    "emissionFactor.wizard.level1.placeholder": "Select Level 1",
    "emissionFactor.wizard.level2": "Level 2",
    "emissionFactor.wizard.level2.placeholder": "Select Level 2",
    "emissionFactor.wizard.level3": "Level 3",
    "emissionFactor.wizard.level3.placeholder": "Select Level 3",
    "emissionFactor.wizard.fuelName": "Fuel Name",
    "emissionFactor.wizard.fuelType": "Fuel Type",
    "emissionFactor.wizard.fuelUnit": "Fuel Unit",
    "emissionFactor.wizard.step1": "Fuel Type",
    "emissionFactor.wizard.step2": "Value",

    "emissionFactor.wizard.onlyKyotoGases": "Emissions containing only Kyoto greenhouse gases",
    "emissionFactor.wizard.onlyNonKyotoGases": "Emissions containing only non-Kyoto greenhouse gases",
    "emissionFactor.wizard.totalIncludingNonKyoto": "Total emissions including non-Kyoto greenhouse gases",

    "emissionFactor.wizard.onlyKyotoGasesValue": "Emissions containing only Kyoto greenhouse gases - Value",
    "emissionFactor.wizard.onlyKyotoGasesUnit": "Emissions containing only Kyoto greenhouse gases - Unit",
    "emissionFactor.wizard.onlyNonKyotoGasesValue": "Emissions containing only non-Kyoto greenhouse gases - Value",
    "emissionFactor.wizard.onlyNonKyotoGasesUnit": "Emissions containing only non-Kyoto greenhouse gases - Unit",
    "emissionFactor.wizard.totalIncludingNonKyotoValue": "Total emissions including non-Kyoto greenhouse gases - Value",
    "emissionFactor.wizard.totalIncludingNonKyotoUnit": "Total emissions including non-Kyoto greenhouse gases - Unit",

    "emissionFactor.versionUpdate.title": "A new version of the emission factors is available.",
    "emissionFactor.versionUpdate.description": "The emission factors used in the calculations for the \"{projectName}\" project are from an older version. Would you like to update all your values according to the emission factors used in the new version?",

    "fileHandler.title": "File Manager",
    "fileHandler.filter.fileType": "File Type",
    "fileHandler.filter.fileType.placeholder": "Select File Type",
    "fileHandler.filter.keyword.placeholder": "Enter File Name, Description ...",
    "fileHandler.column.fileName": "File Name",
    "fileHandler.column.fileType": "File Type",
    "fileHandler.column.uploadedBy": "Uploaded By",
    "fileHandler.column.uploadedAt": "Uploaded At",
    "fileHandler.column.description": "Description",
    "fileHandler.column.size": "Size",
    "fileHandler.column.location": "Location",
    "fileHandler.view.unAuthorized": "File view permission is not granted.",
    "fileHandler.delete.error": "File deletion failed. Please try again.",
    "fileHandler.delete.success": "File deleted successfully.",
    "fileHandler.delete.warning": "Are you sure you want to delete this file?",
    "fileHandler.description.placeholder": "Enter description",
    "fileHandler.preview.error": "File cannot be previewed.",
    "fileHandler.download.error": "File could not be downloaded",
    "fileHandler.select.required": "Please select a file to upload.",
    "fileHandler.uploaded": "Uploaded Files",
    "fileHandler.operations": "File Operations",
    "fileHandler.none.title": "No Files Found",
    "fileHandler.none.subtitle": "You can upload a file or contact your administrator.",

    "plants.title": "Facilities",

    "action.reset": "Reset",
    "action.sendRequest": "Send Request",
    "action.delete": "Delete",
    "action.delete.confirm": "Are you sure you want to delete?",
    "action.edit": "Edit",
    "action.save": "Save",
    "action.cancel": "Cancel",
    "action.cancel.confirm": "Are you sure you want to cancel?",
    "action.add": "Add",
    "action.search": "Search",
    "action.update": "Update",
    "action.clear": "Clear",
    "action.dataEntry": "Data Entry",
    "action.uploadFile": "Upload File",
    "action.uploadFile.description": "Click or drag file to this area to upload",
    "action.uploadFile.hint": "You can upload one file at a time.",
    "action.refresh": "Refresh",
    "action.exportExcel": "Export to Excel",
    "action.undoChanges": "Undo Changes",
    "action.ok": "Ok",
    "action.discardChanges": "Discard Changes",
    "action.back": "Back",
    "action.next": "Next",
    "action.remove": "Remove",
    "action.changePassword": "Change Password",
    "action.sendInvitation": "Send Invitation",
    "action.addRow": "Add Row",
    "action.airportSearch": "Search Airport",
    "action.copy": "Copy",
    "action.approveAll": "Approve All",
    "action.cancelAll": "Cancel All",
    "action.approve": "Approve",
    "action.approval.confirmMessage": "The data will be approved. Do you want to continue?",
    "action.approval.revokeConfirm": "The approval will be revoked. Do you want to continue?",
    "action.close": "Close",
    "action.hide": "Hide",
    "action.show": "Show",
    "action.download": "Download",
    "action.approve.selected": "Approve selected",
    "action.revoke.selected": "Revoke approval",
    "table.selection.mixed.status.warning": "Selected rows have different approval statuses.",
    "table.selection.empty": "No valid selected rows.",

    "filter.title": "Search Settings",
    "filter.apply": "Apply Filter",
    "filter.applied": "Filter Applied",
    "filter.keyword.title": "Keyword",
    "filter.rangePicker.title": "Date Range",

    "sort.title": "Sorting",
    "sort.projectName.asc": "Project Name (A-Z)",
    "sort.projectName.desc": "Project Name (Z-A)",
    "sort.date.desc": "Newest First",
    "sort.date.asc": "Oldest First",
    "sort.clientName.asc": "Client Name (A-Z)",
    "sort.clientName.desc": "Client Name (Z-A)",
    "sort.companyName.asc": "Company Name (A-Z)",
    "sort.companyName.desc": "Company Name (Z-A)",
    "sort.username.asc": "Username (A-Z)",
    "sort.username.desc": "Username (A-Z)",

    "date.startEnd": "Start/End",
    "date.end": "End Date",
    "date.start": "Start Date",
    "date.today": "Today",
    "date.yesterday": "Yesterday",
    "date.last3Days": "Last 3 Days",
    "date.lastWeek": "Last 1 Week",
    "date.lastMonth": "Last 1 Month",
    "date.last3Months": "Last 3 Months",
    "date.last6Months": "Last 6 Months",
    "date.lastYear": "Last 1 Year",
    "date.format": "YYYY-MM-DD",
    "date.formatWithTime": "YYYY-MM-DD HH:mm:ss",
    "date.formatAddTimeExtendedAccountPage": "YYYY-MM-DD HH:mm:ss",
    "date.customFormat": "D MMMM YYYY",
    "date.monthYear": "YYYY/MM",

    "table.columnSettings": "Column Show/Hide/Sort",
    "table.columnNotVisible": "Column Not Visible",

    "form.project": "Project",
    "form.project.placeholder": "Select Project",
    "form.customer": "Client",
    "form.customer.placeholder": "Select Client",
    "form.customer.required": "Client is required!",
    "form.supplier": "Supplier",
    "form.supplier.placeholder": "Select Supplier",
    "form.supplier.required": "Supplier is required!",
    "form.account": "Account",
    "form.companyName": "Company Name",
    "form.companyName.placeholder": "For example: Life İklim ve Enerji Ltd. Şti.",
    "form.companyName.required": "Company name is required!",
    "form.shortTitle": "Short Title",
    "form.shortTitle.placeholder": "For example: Life İklim",
    "form.shortTitle.required": "Short title is required!",
    "form.contactPerson": "Contact Person",
    "form.contactPerson.required": "Contact person is required!",
    "form.email": "Email",
    "form.email.label": "Email Address",
    "form.email.required": "Please enter your email address!",
    "form.email.invalid": "Please enter a valid email address!",
    "form.phone": "Phone",
    "form.phone.required": "Phone is required!",
    "form.taxNumber": "Tax Number",
    "form.taxNumber.required": "Tax number is required!",
    "form.taxOffice": "Tax Office",
    "form.taxOffice.required": "Tax office is required!",
    "form.address": "Address",
    "form.address.required": "Address is required!",
    "form.city": "City",
    "form.city.required": "City is required!",
    "form.region": "Region",
    "form.region.required": "Region is required!",
    "form.country": "Country",
    "form.country.placeholder": "Select Country",
    "form.country.required": "Country is required!",
    "form.nace": "NACE Code",
    "form.nace.placeholder": "Select NACE Code",
    "form.nace.required": "NACE code is required!",
    "form.naceCode.selectionOptional": "NACE Code - Selection is optional. If not selected, the NACE code will be taken from the customer information",
    "form.organizationBoundaryMethods": "Organization Boundary Methods",
    "form.organizationBoundaryMethods.placeholder": "Select Organization Boundary Methods",
    "form.organizationBoundaryMethods.required": "Organization Boundary Methods is required!",
    "form.annualProductionVolume": "Production Volume (%)",
    "form.annualProductionVolume.required": "The annual production volume field is required!",
    "form.annualProductionVolume.placeholder": "Portion of production volume dedicated to this customer (e.g., 25%)",
    "form.organizationFundingShare": "Organization Funding Share",
    "form.organizationFundingShare.placeholder": "Organization funding share (e.g., 25%)",
    "form.username": "Username",
    "form.username.required": "Username is required.",
    "form.oldPassword": "Old Password",
    "form.newPassword": "New Password",
    "form.confirmPassword": "Confirm New Password",
    "form.newPassword.required": "Please enter a new password (cannot be empty)!",
    "form.newPassword.minLength": "Password must be at least 6 characters!",
    "form.confirmPassword.required": "Please confirm your new password (cannot be empty)!",
    "form.confirmPassword.mismatch": "New password and confirmation do not match!",
    "form.firstName": "First Name",
    "form.firstName.required": "First name is required.",
    "form.lastName": "Last Name",
    "form.lastName.required": "Last name is required.",
    "form.addCustomer": "Add Customer",
    "form.title": "Title",
    "form.filePermissions": "File Permissions",
    "form.role": "Role",
    "form.role.placeholder": "Select Role",
    "form.startEndDate": "Start - End Date",
    "form.projectName": "Project Name",
    "form.companyName.title.required": "Please enter your company name completely and accurately!",
    "form.requiredField": "Required field!",
    "form.email.preferredLocale.label": "Email Language",
    "form.email.preferredLocale.help": "Choose the language for emails sent to you.",
    "form.email.preferredLocale.option.trTR": "Turkish",
    "form.email.preferredLocale.option.enUS": "English",
    "form.flight.notData.label": "Flight data is not available",
    "form.longitude.placeholder": "For example: 29.0111",
    "form.latitude.placeholder": "For example: 41.1234",
    "form.coordinates": "Coordinates",
    "form.district": "District",
    "form.coordinates.invalid": "Invalid coordinates format. Please enter in 'latitude, longitude' format.",

    "wizard.projectNetwork": "Project Network",
    "wizard.selection.none": "No selection made yet",
    "wizard.tabs.title.general": "General",
    "wizard.tabs.title.user": "User",
    "wizard.purchasedQuantity": "Purchased Product Quantity",
    "wizard.noDataDueToNoSupplier": "No data is available because no supplier has been selected.",

    "search.placeholder.generic": "You can search",
    "search.placeholder.taxNumber": "You can search by tax identification number",

    "validation.fillAllSelections": "Please fill in all selections.",

    "travel.air": "Air Travel",
    "travel.sea": "Sea Travel",
    "travel.land": "Land Travel",

    "trip.oneWay": "One Way",
    "trip.roundTrip": "Round Trip",

    "admin": "Admin",
    "customer": "Customer",
    "supplier": "Supplier",
    "auditor": "Auditor",

    "FinancialControl": "Financial Control",
    "OperationalControl": "Operational Control",
    "EquityShare": "Equity Share",

    "scope1": "Scope 1",
    "scope2": "Scope 2",
    "scope3": "Scope 3",
    "category1": "Category 1",
    "category2": "Category 2",
    "category3": "Category 3",
    "category4": "Category 4",
    "category5": "Category 5",
    "category6": "Category 6",

    "stationaryCombustionGHG": "Stationary Combustion",
    "processEmissionsGHG": "Process Emissions",
    "fugitiveEmissionsGHG": "Fugitive Emissions",
    "mobileCombustionGHG": "Mobile Combustion",
    "electricityPurchasesGHG": "Purchased Electricity",
    "purchasedHeatEmissionsGHG": "Purchased Energy",
    "purchasedGoodsEmissionsGHG": "Purchased Goods and Services",
    "capitalGoodsEmissionsGHG": "Capital Goods",
    "otherGHG": "Fuel and Energy Related Activities",
    "upstreamTransportationEmissionsGHG": "Upstream Transportation and Distribution",
    "operationalWasteEmissionsGHG": "Waste Generated in Operations",
    "flightsGHG": "Business Travel",
    "employeeCommutingEmissionsGHG": "Employee Commuting",
    "leasedAssetsEmissionsGHG": "Upstream Leased Assets",
    "downstreamTransportationEmissionsGHG": "Downstream Transportation and Distribution",
    "purchasingProcessingGHG": "Processing Of Sold Products",
    "productUseEmissionsGHG": "Use Of Sold Products",
    "eolGHG": "End-Of-Life Treatment of Sold Products",
    "leasedAssetsDownstreamEmissionsGHG": "Downstream Leased Assets",
    "franchiseBranchEmissionsGHG": "Franchises",
    "investmentEmissionsGHG": "Investments",

    "stationaryCombustionISO": "Stationary Combustion",
    "mobileCombustionISO": "Mobile Combustion",
    "processEmissionsISO": "Industrial Processes",
    "fugitiveEmissionsISO": "Anthropogenic Systems",
    "lulucfEmissionsISO": "Land Use, Land Use Change and Forestry",
    "purchasedElectricityEmissionsISO": "Imported Electricity",
    "purchasedHeatEmissionsISO": "Imported Energy",
    "upstreamTransportationEmissionsISO": "Upstream Transport and Distribution",
    "downstreamTransportationEmissionsISO": "Downstream Transport and Distribution",
    "employeeCommutingEmissionsISO": "Employee Commuting",
    "clientTransportEmissionsISO": "Client and Visitor Transport",
    "businessTravelEmissionsISO": "Business Travel",
    "purchasedMaterialsISO": "Purchased Goods",
    "capitalGoodsEmissionsISO": "Capital Goods",
    "operationalWasteEmissionsISO": "Disposal of Solid and Liquid Waste",
    "leasedAssetsEmissionsISO": "Upstream Leased Assets",
    "purchasedGoodsEmissionsISO": "Purchased Services",
    "productUseEmissionsISO": "Use Stage of The Product",
    "leasedAssetsDownstreamEmissionsISO": "Downstream Leased Assets",
    "eolISO": "End-of-Life Stage of The Products",
    "investmentEmissionsISO": "Investments",
    "otherISO": "Other",

    "taxNumber.notFound.invite": "No record was found for the tax number. You can invite by entering the email address.",

    "relation.dir.up": "Inbound to Organization (Upstream)",
    "relation.dir.down": "Outbound from Organization (Downstream)",
    "relation.dir.unknown": "Other"
  }
};

export default EnLang;
